// extracted by mini-css-extract-plugin
var _1 = "TemplatePickerFooter_actionsContainer__89177";
var _2 = "TemplatePickerFooter_buttons__60065";
var _3 = "TemplatePickerFooter_close__eeda7";
var _4 = "TemplatePickerFooter_leftSide__189f7";
var _5 = "TemplatePickerFooter_modalFooter__48097";
var _6 = "TemplatePickerFooter_remove__bf04f";
var _7 = "TemplatePickerFooter_selected__c99e0";
var _8 = "TemplatePickerFooter_selectedTitle__ed9ab";
export { _1 as "actionsContainer", _2 as "buttons", _3 as "close", _4 as "leftSide", _5 as "modalFooter", _6 as "remove", _7 as "selected", _8 as "selectedTitle" }
